import { cn } from '@/shared/lib'
import { Button, Icon } from '@/shared/ui'

type Props = {
  className?: string
}

export const ScrollTopButton = ({ className }: Props) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Button
      color="secondary"
      size="large"
      shape="pill"
      className={cn(
        'h-12 w-12 bg-white shadow-[0_-3px_7px_0_rgba(0,0,0,0.05),0_0_7px_0_rgba(0,0,0,0.05),0_5px_6px_0_rgba(0,0,0,0.11)]',
        'hover:bg-white!',
        className,
      )}
      onClick={handleClick}
    >
      <Icon name="arrow-up" size={24} className="text-black" />
      <span className="sr-only">스크롤을 맨 위로 이동</span>
    </Button>
  )
}
